import { render, staticRenderFns } from "./MemberPublic.vue?vue&type=template&id=483c6838&scoped=true"
import script from "./MemberPublic.vue?vue&type=script&lang=js"
export * from "./MemberPublic.vue?vue&type=script&lang=js"
import style0 from "./MemberPublic.vue?vue&type=style&index=0&id=483c6838&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c6838",
  null
  
)

export default component.exports